import { Button } from '@repo/shadcn';
import { FC } from 'react';
import { z } from 'zod';

import { IwForm } from '@components/form';
import { TextField } from '@components/form/fields';
import { SectionTitle } from '@components/ui';

const StrengthFormSchema = z.object({
    name: z.string().min(1, 'Name is required'),
});

export type TStrengthForm = z.infer<typeof StrengthFormSchema>;

type StrengthFormProps = {
    initialValues: TStrengthForm;
    onSubmit?: (data: TStrengthForm) => Promise<void>;
    isLoading?: boolean;
    title?: string;
};

export const StrengthForm: FC<StrengthFormProps> = ({
    initialValues,
    onSubmit,
    isLoading = false,
    title = 'Strength Form',
}) => {
    return (
        <div>
            <SectionTitle>{title}</SectionTitle>
            <IwForm
                schema={StrengthFormSchema}
                initialValues={initialValues}
                onSubmit={onSubmit as any}
            >
                <div className={'flex flex-col space-y-4'}>
                    <TextField<TStrengthForm>
                        name={'name'}
                        label={'Name'}
                        placeholder={'Enter strength name'}
                    />

                    <div className={''}>
                        <Button type={'submit'} disabled={isLoading}>
                            {isLoading ? 'Saving...' : 'Save Changes'}
                        </Button>
                    </div>
                </div>
            </IwForm>
        </div>
    );
};

StrengthForm.displayName = 'StrengthForm';
